
export default {
  'maps': {
    'pageTitle': 'ORS Maps',
    'Places': 'Lieux',
    'isochrones': 'Isochrones',
    'placeNameRequired': 'Nom de lieu requis',
    'altitude': 'Variation d\'altitude',
    'settings': 'Réglages',
    'toggleAccessibleMode': 'Basculer en mode accessible',
    'aboutTitle': 'À propos d\'ORS',
    'updateSearch': 'Rechercher dans cette zone',
    'updateSearchAfterZoomOrCenterChange': 'Mettre à jour la recherche après un changement de zoom ou de centre',
    'pageNotFound': 'Page non trouvée. Vérifiez que l\'URL n\'est pas incomplète ou incorrecte'
  },
}
